export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir empaques"])},
          "total_packages": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Total de empaques: ", _interpolate(_named("total"))])}
        }
      }
    }
  })
}